const DEFAULT_TICKER_KEYWORDS = ["performance", "charts", "market data"];

export function buildTickerKeywords(
  longName: string,
  ticker: string,
  keywords = DEFAULT_TICKER_KEYWORDS
) {
  const tickerKeywords = keywords.reduce(
    (acc, keyword) => {
      acc.push(`${longName} ${keyword}`);
      acc.push(`${ticker} ${keyword}`);

      return acc;
    },
    [longName, ticker]
  );

  return tickerKeywords.join(", ");
}
